import { getAppCheckTokenValue } from "../firebase";

export async function postFunctionJson(url, { authToken = "", body = {}, includeAppCheck = true } = {}) {
  const headers = {
    "Content-Type": "application/json",
  };

  if (includeAppCheck) {
    const appCheckToken = await getAppCheckTokenValue();
    if (appCheckToken) {
      headers["X-Firebase-AppCheck"] = appCheckToken;
    }
  }

  return fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify({
      ...body,
      ...(authToken ? { authToken } : {}),
    }),
  });
}
